import * as Website from './website';
import * as Admin from './admin';
import * as Auth from './auth';
import { all } from 'redux-saga/effects';

export function* watchers() {
  yield all([Website.watchers(), Admin.watchers(), Auth.watchers()]);
}
